import draggable from 'vuedraggable'
import _ from 'lodash'

export default
{
    components:
    {
        draggable
    },
    computed:
    {
        selectedItems()
        {
            let array = []
            if (this.selected && this.items)
            {
                for (let i = 0; i < this.selected.length; i++) {
                    if (this.selected[i].selected)
                    {
                        array.push(this.selected[i])
                    }
                }
            }
            return array
        },
    },
    methods:
    {
        fetch()
        {
            this.loading = true
            this.$store.dispatch(this.action.fetch, {
                page: this.$route.params.page || 1,
                sort: this.$route.params.sort || 'id',
                order: this.$route.params.order || 'asc',
                search:  this.$route.params.search || null,
                channel: this.$route.query.channel || null,
            })
            .then((res)=> {
                this.selected = []
                this.selectedHelper = []
                for (let i = 0; i < this.items.data.length; i++)
                {
                    this.selected.push(Object.assign({},this.items.data[i], {selected:false}))
                }
                this.$nextTick(() => {
                    this.loading = false
                })
            })
            .catch(e => this.loading = false)
        },
        onSearch: _.debounce(function()
        {
            this.$router.push({
                name: this.subPageName,
                params: {
                    page: this.$route.params.page,
                    sort: this.$route.params.sort,
                    order: this.$route.params.order,
                    search: this.search ? encodeURIComponent(this.search) : null,
                }, query: this.$route.query
            })
        }, 500),
        export_all()
        {
            for (let i = 0; i < this.selected.length; i++)
            {
                for (let j = 0; j < this.items.data.length; j++)
                {
                    if (this.selected[i].stacked_offer_id == this.items.data[j].stacked_offer_id )
                    {
                        this.export_item(this.items.data[j])
                    }
                }
            }
        },
        export_item(offer)
        {
            console.log(offer)
        },
        recover(offer)
        {
            this.selectedHelper = []
            this.selectedHelper.push(offer)
            this.$refs.recoverSingleModal.openModal()
        },
        onDragEnd(row)
        {
            if (row && row.moved && row.moved.element)
            {
                const query = {
                    element: row.moved.element.id,
                    order: row.moved.element.order,
                    to: row.moved.newIndex - row.moved.oldIndex,
                }
                this.$store.dispatch(this.action.reorder, query).then( e => {
                    this.fetch()
                })
            }
        },
        setActive(offer)
        {
            this.selectedHelper = []
            this.selectedHelper.push(offer)
            this.$refs.reliveSingleModal.openModal()
        },
        setInActive(offer)
        {
            this.selectedHelper = []
            this.selectedHelper.push(offer)
            this.$refs.suspendSingleModal.openModal()
        },
    },
    watch:
    {
        '$route':
        {
            handler()
            {
                this.fetch()
            },
            immediate: true
        },
        search(value)
        {
            if (value.length > 2)
            {
                this.onSearch()
            } else {
                this.onSearch()
            }
        },
        all_selected(value)
        {
            if (value)
            {
                for (let i = 0; i < this.items.data.length; i++)
                {
                    this.selected[i].selected = true
                }
            } else {
                for (let i = 0; i < this.items.data.length; i++)
                {
                    this.selected[i].selected = false
                }
            }
        }
    },

    data()
    {
        return {
            loading: true,
            search: '',
            all_selected: false,
            selected:[],
            selectedHelper: [],
        }
    },
}



// WEBPACK FOOTER //
// ./src/mixins/list/list.js